import React from 'react'
import useAuth from './useAuth'
import { useQuery } from 'react-query'
import { getAccountInformation } from 'api'
import { useNavigate } from 'react-router-dom'
import { navigateLandingSSR } from 'utils/navigateLandingSSR'

const useAccountInformation = (navigateTo = '') => {
  const { setProfileUser, setRoleUser } = useAuth()
  const navigate = useNavigate()
  const { refetch, isLoading, isFetching, isRefetching } = useQuery({
    queryKey: 'getAccountInformationQuery',
    queryFn: () => getAccountInformation(),
    onSuccess: ({ data }) => {
      setProfileUser(data)
      setRoleUser(data?.roles)
      setTimeout(() => {
        if (navigateTo == '/') {
          return navigateLandingSSR()
        }
        if (navigateTo !== '') {
          navigate(navigateTo, { replace: true })
        }
      }, [1000])
    },
    onError: () => {},
    enabled: false
  })

  return {
    updateAccountInformation: refetch,
    isAccountInformationLoading: isLoading || isFetching || isRefetching
  }
}

export default useAccountInformation
